import React from 'react';

export default function SleepSwitch({ isOn, setIsOn }) {
    const toggleSwitch = () => {
        setIsOn(!isOn);
    };

    return (
        <div className="sleep-row" onClick={() => setIsOn(!isOn)} role="button" aria-pressed={!isOn}>
            <div className={`switch ${isOn ? 'on' : ''}`} />
            {/* <span className="sleep-icon">{isOn ? '☀️' : '🌙'}</span> */}
        </div>
    );
}
